export type VercelEnv = 'production' | 'preview' | 'development';

export const VERCEL_ENVS: VercelEnv[] = ['production', 'preview', 'development'];

export const isVercelEnv = (env: string): env is VercelEnv => {
  return VERCEL_ENVS.some((validEnv) => validEnv === env);
};

export const getVercelEnv = (env: string): VercelEnv => {
  return isVercelEnv(env) ? env : 'development';
};
